import { IAppointmentButtonSettings } from '@/types';

export const defaultButtonsSettings: Record<
  string,
  IAppointmentButtonSettings
> = {
  schedule: {
    isSolid: false,
    colors: {
      background: '#001535',
      text: '#ffffff',
      highlight1: '#144693',
      highlight2: '#3476D8',
    },
  },
  onDemand: {
    isSolid: false,
    colors: {
      background: '#001535',
      text: '#ffffff',
      highlight1: '#A92E00',
      highlight2: '#F47E52',
    },
  },
  iHaveAppointment: {
    isSolid: false,
    colors: {
      background: '#001535',
      text: '#ffffff',
      highlight1: '#005244',
      highlight2: '#00A88E',
    },
  },
};

export const weekdayStringToDayjsNumberMap = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const KIOSK_AVAILABILITY_RECHECK_INTERVAL = 10 * 1000; // 10 secs in ms

export const MULTILINE_INPUT_MAX_LENGTH = 13500;

// Touch screens (phones and tablets): no hover, and front and back cameras to
// flip between. Written as a comma list, which every browser reads, unlike
// the newer `or` syntax.
export const TOUCH_SCREEN_QUERY = '(pointer: coarse), (pointer: none)';

// The video call's mobile layout: narrow windows as well as touch devices, so a
// phone held in landscape (wider than the breakpoint) keeps the same layout as
// in portrait. EncounterHeader.module.css repeats it in a media query.
export const CALL_MOBILE_LAYOUT_QUERY = `(max-width: 768px), ${TOUCH_SCREEN_QUERY}`;

// Screens under 360px wide, where the mobile call panel has no room for the
// end call button's label and shows its icon alone.
export const CALL_PANEL_ICON_ONLY_QUERY = '(max-width: 359.98px)';

export const ORG_INSTITUTION_PROFILE_FIELDS = [
  'name',
  'language',
  'country',
  'state',
  'address1',
  'address2',
  'city',
  'zip',
];
